<template>
  <div class="container pos-r login-phone">
    <!-- <div class="tip-logo pos-ab"></div> -->
    <div class="logo txt-c" @touchstart="mouseEnter" @touchend="touchEnd">
      <img src="../../assets/images/login/logo.png"/>
    </div>
    <!-- 手机号登录表单 -->
    <section class="login p18">
      <van-cell-group :border=false>
        <van-field placeholder="请输入手机号码" type="tel" maxlength="11" v-model="CellPhoneNo"/>
        <van-field placeholder="短信验证码" type="tel" maxlength="6" :value="Captcha" @input="onCaptchaInput" autocomplete="one-time-code">
          <van-button slot="button" size="small" class="btn-bl c-orange" type="default" @click="sendCaptcha">
            {{btnCodeText}}
          </van-button>
        </van-field>
      </van-cell-group>
      <van-button block type="primary" class="btn-gradient" :disabled="btnDisabled" @click="phoneLogin">
        <span class="f16">登录</span>
      </van-button>
    </section>
    <!-- 服务协议复选框 -->
    <div class="agreement-checkbox">
      <van-checkbox v-model="agreeToTerms"  checked-color="#FD6404" shape="square">
        <span class="f12 c-gray">我已阅读并同意</span>
        <span class="c-orange" @click.stop="go('agreement')">《服务协议与隐私条款》</span>
      </van-checkbox>
    </div>
   
    <!-- 原手机号登录入口（已注释）
    <section class="login-box txt-c pos-ab">
      <p class="c-gray mt36" @click="go('login-phone')">手机号登录
        <span class="icon icon-guanbi1 f12"></span>
      </p>
    </section>
    -->
    <!-- <van-action-sheet v-model="devShow" :actions="actions" @select="onSelect" />
    <van-dialog v-model="showCustom" title="自定义URL"  show-cancel-button  @confirm="setCustomUrl">
      <van-field v-model="customUrl" style="border-bottom: 1px solid #000" placeholder="" />
    </van-dialog> -->
  </div>
</template>

<script>
  import { wxOauth } from '../../libs/native-app';
  import login from '../../mixins/login';
  import captcha from '../../mixins/captcha';
  import { ActionSheet } from 'vant';

  export default {
    name: 'login-wechat',
    mixins: [login, captcha],
    components: {ActionSheet},
    data() {
      return {
        // 手机号登录相关
        CellPhoneNo: '',
        Captcha: '',
        CaptchaType: 1,
        agreeToTerms: false, // 同意条款复选框状态
        loginForm: {
          LoginSource: 1,
          LoginType: 1,
          LoginPwd: '',
          RegisterMsg: { IsNeedRegister: 1 }
        },
        // 开发者工具相关
        actions: [ { name: '环境设置',url:'custom' },{name: '设置Header',url:'setHeader' }],
        timeout:null,
        devShow:false,
        showCustom:false,
        customUrl:window.localStorage.getItem('CUSTOM_URL')||""
      };
    },
    mounted() {
      this.$store.commit('updateLoginForm', null);
    },
    computed: {
      btnDisabled() {
        return !this.validMobile() || this.Captcha.length < 6;
      }
    },
    methods: {
      // 处理验证码输入，防止iOS自动填充重复
      onCaptchaInput(value) {
        // 只保留数字，并截取前6位
        this.Captcha = String(value).replace(/\D/g, '').slice(0, 6);
      },
      // 手机号登录
      async phoneLogin() {
        if (!this.agreeToTerms) {
          this.$toast('请先勾选同意《服务协议与隐私条款》');
          return;
        }
        try {
          this.$loading();
          this.loginForm.LoginID = this.CellPhoneNo;
          this.loginForm.LoginType = 5;
          this.loginForm.CellPhoneNo = this.CellPhoneNo;
          this.loginForm.Captcha = this.Captcha;
          await this.login();
          this.$loadingClose();
        } catch (e) {
          this.$error(e.message);
        }
      },
      // 微信登录（已注释）
      // async wxLogin() {
      //   try {
      //     this.$loading('请稍后', 5000);
      //     const wxData = await wxOauth();
      //     const headimgurl = wxData.headimgurl || wxData.profile_image_url;
      //     if (headimgurl) this.loginForm.RegisterMsg.FilePathList = [headimgurl];
      //     this.loginForm.RegisterMsg.WxUnionID = wxData.unionid;
      //     this.loginForm.RegisterMsg.PersonName = wxData.nickname || wxData.screen_name;
      //     this.loginForm.LoginID = wxData.unionid;
      //     this.$store.commit('updateLoginForm', this.loginForm);
      //     const check = await this.$store.dispatch('postData', {
      //       url: '/common/CheckLoginInStatus2',
      //       data: { Body: this.loginForm }
      //     });
      //     if (check.LoginInStatus === 3) {
      //       this.$error('账号无法登录，请联系管理员');
      //     } else if (!check.LoginInStatus || !check.Person.CellPhoneNo) {
      //       this.go(`bind-phone`);
      //     } else {
      //       await this.login();
      //     }
      //     this.$loadingClose();
      //   } catch (e) {
      //     this.$error(e.message);
      //   }
      // },
      mouseEnter() {
        this.timeout = setTimeout(() => {
          this.devShow = true;

        }, 3000);
      },
      touchEnd() {
        this.timeout && clearTimeout(this.timeout);
      },
      onSelect(item){
        console.log(item)
        if(item.url === 'custom'){
          uni.navigateTo({url:'/pages/config/config'});
        }else if(item.url === 'setHeader'){
          this.go('/setHeader');
        }else{
          window.localStorage.setItem('CUSTOM_URL', item.url);
        }
        this.devShow=false
      },
      setCustomUrl(){
        window.localStorage.setItem('CUSTOM_URL', this.customUrl);
      }

    }
  };
</script>

<style lang="less">
  .tip-logo {
    // background: url('../../assets/images/login/login-tip.png') no-repeat;
    // background-size: contain;
    right: 0;
    top: 0;
    width: 202px;
    height: 102px;
  }

  .logo img {
    width: 200px;
    height: 170px;
    margin-top: 128px;
  }

  .login-box {
    width: 100%;
    left: 0;
    bottom: 60px;
  }

  .wx-load {
    background: #07C160;
    width: 80%;
    border: 0 none;
    border-radius: 5px;
  }

  .login-phone .tip-pos {
    width: 100%;
    bottom: 27px;
    left: 0;
  }

  .agreement-checkbox {
    position: absolute;
    bottom: 27px;
    left: 0;
    width: 100%;
    text-align: center;
  }

  .agreement-checkbox .van-checkbox {
    justify-content: center;
  }

  .agreement-checkbox .van-checkbox__label {
    font-size: 12px;
    color: #666;
  }

</style>
